export const canUsed = navigator.cookieEnabled && !!window.localStorage

export default {
  /**
   * 获取本地储存
   * @param {String}  key     存储的 key 值
   * @param {Object}  options 附加配置
   */
  get (key, options = {}) {
    let response = {}

    if (!canUsed) {
      return response
    }

    let localCache = decodeURIComponent(localStorage.getItem(key))

    try {
      if (localCache !== 'null') {
        response = JSON.parse(localCache)
      }
    } catch (e) {
      response = localCache
    }

    return response
  },
  /**
   * 设置本地储存
   * @param {String}  key              存储的 key 值
   * @param {Any}     value            存储的值
   * @param {Object}  options          附加配置
   * @param {Boolean} options.unEncode 是否不做 encode 处理
   */
  set (key, value, options = {}) {
    if (!canUsed) {
      return
    }

    this.remove(key)

    if (typeof value !== 'string') {
      value = JSON.stringify(value)
    }

    if (options.unEncode) {
      localStorage.setItem(key, value)
    } else {
      localStorage.setItem(key, encodeURIComponent(value))
    }
  },
  /**
   * 筛选本地储存
   * @param {String}  key     存储的 key 值
   * @param {Object}  options 附加配置
   */
  filter (key, options = {}) {
    let response = {}

    if (!canUsed) {
      return response
    }

    if (typeof key === 'string') {
      key = new RegExp('^' + key)
    }

    for (let name in localStorage) {
      if (name.match(key)) {
        response[name] = this.get(name, options)
      }
    }

    return response
  },
  /**
   * 移除本地储存
   * @param {String}  key     存储的 key 值
   * @param {Object}  options 附加配置
   */
  remove (key, options = {}) {
    if (!canUsed) {
      return
    }

    localStorage.removeItem(key)
  },
  /**
   * 根据模糊过滤移除本地储存
   * @param {String}  key     存储的 key 值
   * @param {Object}  options 附加配置
   */
  removeFilter (key) {
    if (!canUsed) {
      return
    }

    if (typeof key === 'string') {
      key = new RegExp('^' + key)
    }

    for (let name in localStorage) {
      if (name.match(key)) {
        this.remove(name)
      }
    }
  }
}
